(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wine-facts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wine-facts')) {
  customElements.define(
    'wine-facts',
    class WineFacts extends HTMLElement {
      connectedCallback() {
        if (this.classList.contains('is-live')) return;
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-live');
          return;
        }
        const io = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              entry.target.classList.add('is-live');
              io.unobserve(entry.target);
            }
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        );
        io.observe(this);
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

})();
